import React from 'react';
import { SvgIcon } from '@onsolve/onsolve-ui-components';

const UsageImage = props => (
    <SvgIcon {...props}>
        <path
            d="M10.341 2l4.577 2.64L16 8.681v2.461l-1.602-5.977-3.442.923-.922-3.441-6.313 1.692L6.845 16H6.28L3.052 3.954 10.341 2zM16 13.955v.659L10.826 16h-2.46L16 13.955zm-1.509-1.763l.165.615-6.328 1.696-.165-.616 6.328-1.695zm-1.165-4.616a.295.295 0 01.382-.078.298.298 0 01.133.355l-.007.015-.016.034-2.077 3.618-.021.031a.295.295 0 01-.335.1l-.016-.006-.033-.016-1.928-1.119-1.109 1.932-.021.031a.294.294 0 01-.332.101l-.018-.006-.032-.016-.031-.021a.295.295 0 01-.101-.334l.006-.016.016-.033 1.258-2.191.02-.031a.3.3 0 01.335-.1l.017.006.033.018 1.927 1.118 1.929-3.36.021-.032zm-.436-1.361l.166.615-6.33 1.696-.164-.615 6.328-1.696zM8.92 5.112l.166.615-2.901.778-.165-.615 2.9-.778zm1.862-2.194l.659 2.461 2.461-.66-3.12-1.801z"
            fillRule="nonzero"
            stroke="none"
        />
    </SvgIcon>
);

export default UsageImage;
